export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: '購入を希望する案件をお知らせください',
      description: 'まずはお電話ください。法人の詳細、また手続きの流れなどご説明いたします。',
      icon: 'ri-search-line',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      number: '02',
      title: '登記の実施についてご説明',
      description: '会社ご買収の際、変更登記の実施が必要です。そちらについてのご説明を行います。',
      icon: 'ri-file-text-line',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      number: '03',
      title: 'ご請求書の発行',
      description: '購入意思が固まりましたら請求書を発行いたします。お代金は前払いですが、手続き完了まで弊社で保全します。売主様のご都合で売買が不成立だった場合などは全額返金いたします。',
      icon: 'ri-file-list-3-line',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      number: '04',
      title: 'ご契約書の捺印',
      description: 'ご契約書を郵送いたしますのでご捺印をください。購入者さまの前に、売主さまに先に捺印頂きます。そちらのお手続きに日数を頂戴する場合がございます。',
      icon: 'ri-quill-pen-line',
      color: 'from-indigo-500 to-purple-500'
    },
    {
      number: '05',
      title: '変更登記',
      description: '変更登記の実施を行っていただきます。',
      icon: 'ri-government-line',
      color: 'from-purple-500 to-pink-500'
    },
    {
      number: '06',
      title: 'お引渡し',
      description: '登記完了次第、法人の書類等お引渡しとなります。',
      icon: 'ri-hand-heart-line',
      color: 'from-pink-500 to-rose-500'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-route-line text-teal-600 text-xl mr-3"></i>
            <span className="text-teal-600 text-sm font-bold">PROCESS</span>
          </div>
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            会社買収の<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">手続きの流れ</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            手続き完了まで、約4週間を想定しております
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-teal-200"
            >
              {/* Step Number */}
              <div className={`absolute -top-6 -right-6 w-20 h-20 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center shadow-xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500`}>
                <span className="text-white text-2xl font-black">{step.number}</span>
              </div>

              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                <i className={`${step.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-black text-gray-900 mb-4 leading-tight">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {step.description}
              </p>

              {/* Hover Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br ${step.color} opacity-0 group-hover:opacity-5 rounded-3xl transition-opacity duration-500`}></div>
            </div>
          ))}
        </div>

        {/* Note Section */}
        <div className="mt-16 bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-10 border border-amber-200">
          <div className="flex items-start">
            <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center mr-6 flex-shrink-0">
              <i className="ri-information-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">補足事項</h4>
              <p className="text-gray-700 leading-relaxed mb-4">
                登記期間中のトラブル防止のため、弊社では下記のようなお取引方法を取らせていただいております。
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                登記実施前に売主様からは法人の印鑑類など物品を、買主様からはお代金を弊社にお預け頂きます。
              </p>
              <p className="text-gray-700 leading-relaxed">
                登記変更の完了次第、売主様へお代金のお支払い、買主様へ法人物品のお引渡しを行います。上記で、譲渡代金の未払い（売主保護）や、譲渡代金の持ち逃げ（買主保護）を防いでおります。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
